import { controls, currencyToNumber, grouped } from "../../controls";

const rpcf50 = {
  label: "CF Reconcilliation",
  starting: true,
  url: "rp101m",
  pageLabel: "Reconcilliation",
  pageType: "history",
  // filteraction: true,
  filter: [

    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),


    ...controls.button({
      tab: "filter",
      label: "Generate",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "reconcileCalamityFund",
        acttype: "serverfunc",
        otherdata: ["branch_code"],
        tableNameField: "cf_recon_table",
        requiredField: ["interest_date", "days", "months", "amount",],
        required: ["interest_date", "days", "months", "amount",],
      }, width: "col-sm-2"
    }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Consolidated Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    pivot: true,

    extraRows: {
      location: "top",
      fields: ["amount"],
      subtotals: {
        by: "type",
        displayIn: "full_name",
      },
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Name",
        accessor: "full_name",
      },
      {
        Header: "ID",
        accessor: "calamity_trn_id",
      },
      {
        Header: "Paid Date",
        accessor: "paid_date",
      },
      {
        Header: "Account No",
        accessor: "account_no",
      },
      {
        Header: "Taluka",
        accessor: "taluka_display",
      },
      {
        Header: "Village",
        accessor: "village_display",
      },
      {
        Header: "Amount",
        accessor: "amount",
        type: "currency"
      }

    ]
  }
};

export default rpcf50;